<script>
export default {
    name: "IconFirePercent"
}
</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 45 44" fill="none">
        <path
            d="M35.5 24.8572C35.5 12.5354 24.6566 6.83485 19.5494 5.5C21.4606 10.2963 21.3566 13.8468 18.8895 18.2221C18.49 18.9305 17.5188 19.0008 16.9824 18.3903L13.8439 14.8183C5.63468 23.5719 10.5906 39.1346 23.5898 38.48C33.1231 37.9999 35.5 29.7341 35.5 24.8572Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M19.5255 31.2488L27.2648 23.5095" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"/>
        <path
            d="M20.463 24.6346C20.1375 24.6346 19.8737 24.3708 19.8737 24.0453C19.8737 23.7199 20.1375 23.4561 20.463 23.4561"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M20.463 24.6346C20.7885 24.6346 21.0523 24.3708 21.0523 24.0453C21.0523 23.7199 20.7885 23.4561 20.463 23.4561"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M26.7302 31.3033C26.4047 31.3033 26.1409 31.0393 26.1409 30.714C26.1409 30.3885 26.4047 30.1248 26.7302 30.1248"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path
            d="M26.7302 31.3033C27.0556 31.3033 27.3194 31.0393 27.3194 30.714C27.3194 30.3885 27.0556 30.1248 26.7302 30.1248"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>

<style scoped lang="scss">

</style>
